// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandySection_container__LC_Pq","header":"ExpandySection_header__wl7Xd","childrenContainer":"ExpandySection_childrenContainer__7A26f"};